/* =====================================================
   NEMI ADVERTORIAL — nemi-advertorial.js
   ===================================================== */

(function () {
  'use strict';

  /* ---- Sticky offer rail scroll behaviour ---- */
  function initStickyRail() {
    var rail = document.getElementById('offer-rail');
    if (!rail) return;
    var parent = rail.parentElement;
    if (!parent) return;
    /* rail is position:sticky by default via CSS — nothing extra needed unless we need JS fallback */
  }

  /* ---- Video click-to-play ---- */
  function initVideos() {
    var wrappers = document.querySelectorAll('[data-video-wrapper]');
    wrappers.forEach(function (wrapper) {
      var video = wrapper.querySelector('video');
      if (!video) return;
      /* Ensure click on wrapper toggles play/pause */
      wrapper.addEventListener('click', function (e) {
        if (e.target.tagName.toLowerCase() === 'video') return;
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    });
  }

  /* ---- Smooth scroll for internal CTA anchors ---- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ---- Init on DOM ready ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initStickyRail();
    initVideos();
    initSmoothScroll();
  }
})();
